/** Invites may run to 120% of a cohort's seats, because not everyone invited joins. */
export const inviteCeiling = (seats) => Math.floor(seats * 1.2);
const EMAIL_ADDRESS = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** A plausible email address: something, an @, a domain with a dot. Identity is the one that knows if it exists. */
export const isEmailAddress = (text) => EMAIL_ADDRESS.test(text);
export const DAY_MS = 86_400_000;
/** Within this many days of its end, a programme is ending soon. */
export const ENDING_SOON_DAYS = 30;
/** Whole days until a YYYY-MM-DD day, negative once it has passed. */
export const daysUntil = (day, now = Date.now()) => Math.ceil((Date.parse(day) - now) / DAY_MS);
/** Whether a programme ends within the ending-soon window and has not ended yet. */
export const endingSoon = (endsOn, now = Date.now()) => {
    const left = daysUntil(endsOn, now);
    return left > 0 && left <= ENDING_SOON_DAYS;
};
/** Days without a session after which a coachee with sessions left has gone quiet. */
export const QUIET_DAYS = 21;
/** Whether a coachee with sessions left has nothing booked and no session in the quiet window. */
export const goneQuiet = (r, now = Date.now()) => !r.nextSessionAt &&
    r.sessionsRemaining > 0 &&
    (r.lastSessionAt === null || now - new Date(r.lastSessionAt).getTime() > QUIET_DAYS * DAY_MS);
/** Whether a member is free to join a programme: never enrolled, or their last one has ended. */
export const programmeOver = (enrollment, now = new Date()) => !enrollment || enrollment.endsOn < now.toISOString().slice(0, 10);
/** A meeting link to open or put in an invite: https only, so a stored value can never run as script. */
export function safeMeetingUrl(url) {
    if (!url)
        return null;
    try {
        return new URL(url).protocol === "https:" ? url : null;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=coaching-rules.js.map